import React from 'react';
import styles from './data-disclaimer.module.scss';

export default function DataDisclaimer({ firstPage }) {
  return (
    <div className={styles.dataDisclaimer}>
      {firstPage ? (
        <p>
          {' '}
          Data sent from this form is transferred to our internal staff via email. Email is not considered secure and there is a possibility that someone can intercept your personal information. Please do not include personal information such as account number, social security number, or other financial data in this form. By clicking
          {' '}
          <strong>Next</strong>
          {' '}
          you are giving us permission to contact you using the contact info above
        </p>
      )
        : <p>Data sent from this form is transferred to our internal staff via email. Email is not considered secure and there is a possibility that someone can intercept your personal information. Please do not include personal information such as account number, social security number, or other financial data in this form. </p>}
    </div>
  );
}
